<div
    class="container"
    [style]="{
        top: y + 'px',
        left: x + 'px',
    }">
    <div class="main">
        <div class="component-container">
            <div
                class="component"
                *ngFor="let item of items"
                (click)="addToCanvas($event, item); $event.stopPropagation()">
                <div class="icon-preview" [class.circle]="item.circle">
                    <mat-icon [svgIcon]="item.svgIcon" class="item-icon"></mat-icon>
                </div>
                <div class="component-name">{{ item.name | translate }}</div>
            </div>
        </div>
    </div>
</div>
